/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllOrganizations = (state: { organization: any }) => state.organization.organizations;
export const selectAllFilteredOrganizations = (state: { organization: any }) => state.organization.filteredOrganizations;
export const selectSelectedOrganization = (state: { organization: any }) => state.organization.selectedOrganization;
export const selectNoOrganization = (state: { organization: any }) => state.organization.noOrganization;
export const selectPaginationOrg = (state: { organization: any }) => state.organization.pagination;